const PREFIX = 'imported-market-';

export const getMarketIdFromMarket = (market: string): string => `${PREFIX}${market}`;

export const getMarketFromMarketId = (marketId: string): string => marketId.replace(PREFIX, '');
